import React, { useState } from 'react';
import Notification from './Notification';
import { useNotifications } from '../../hooks/useNotifications';
import { RiZzzFill } from 'react-icons/ri';
import classNames from '../../utility/classNames';
import { GoChevronDown } from 'react-icons/go';

export default function Notifications({ type = 'dashboard' }) {
  const {
    notifications,
    markNotificationAsRead,
    deleteNotification,
    markAllAsRead,
    deleteAllNotifications,
  } = useNotifications();

  const [expanded, setExpanded] = useState(true);

  return (
    <section className="max-w-md" aria-label="notifications">
      {type === 'dashboard' && (
        <div
          className={classNames(
            'flex justify-between px-4 py-2',
            !expanded && 'bg-white rounded shadow'
          )}
        >
          <h1 className="text-2xl font-semibold text-neutral-800">
            Notifications
          </h1>
          <GoChevronDown
            aria-label="Expand Notifications"
            className={classNames(
              'text-neutral-900 h-8 w-8 mt-[2px] hover:text-primary cursor-pointer',
              expanded && 'transform rotate-180'
            )}
            onClick={() => setExpanded(!expanded)}
          />
        </div>
      )}
      {expanded && (
        <div className="max-h-[400px] max-w-md overflow-y-auto rounded-lg shadow-md">
          <div className=" max-w-md bg-white rounded-lg border border-neutral-200">
            {!notifications?.length ? (
              <div className="text-center flex justify-center items-center gap-2 text-gray-500 p-10">
                No Notifications <RiZzzFill className="inline-block text-xl" />
              </div>
            ) : (
              <>
                <div className="w-full border-b">
                  <button
                    className="w-1/2 px-2 py-1 text-center  tracking-wider text-base border-r  hover:text-primary-600  focus:text-primary-600"
                    type="button"
                    onClick={() => markAllAsRead()}
                  >
                    <span className="sr-only">Mark All Read</span>
                    Mark All as Read
                  </button>
                  <button
                    className="w-1/2 px-2 py-1 text-center tracking-wider text-base border-l  hover:text-red-700  focus:text-red-700"
                    type="button"
                    onClick={() => deleteAllNotifications()}
                  >
                    <span className="sr-only">Dismiss All</span>
                    Dismiss All
                  </button>
                </div>
                <ul className="rounded-lg">
                  {notifications.map((notification, i) => {
                    const position =
                      i === 0
                        ? 'top'
                        : i === notifications.length - 1
                        ? 'bottom'
                        : 'middle';
                    return (
                      <li key={notification.id} className="flex items-center">
                        <div className="flex-1">
                          <Notification
                            notification={notification}
                            markAsRead={markNotificationAsRead}
                            deleteNotification={deleteNotification}
                            position={position}
                          />
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </>
            )}
          </div>
        </div>
      )}
    </section>
  );
}
